import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { ChartLegendItem } from './ChartLegendItem';
import { ChartLegendList } from './ChartLegendList';
import { generateColorRange, mergeSlices } from '../chartsUtils';
import styles from './chart_legend.module.scss';
import { numberWithSpaces } from '../../../utils/math';

type BaseProps = {
  data: Array<number>;
  labels: Array<string>;
  baseH: number;
  limit?: number;
  handleClick?: (wantToOpenInNewTab: boolean, index: number) => void;
};

export const ChartDecisionLegend: FC<BaseProps> = (props) => {
  const decisionLabel = (label: string, value: number) => (
    <FormattedMessage
      id="legend/ChartLegend.tsx/1"
      values={{ label, value, formattedValue: numberWithSpaces(value) }}
    />
  );

  return <ChartLegend {...props} labelFormater={decisionLabel} />;
};

export const ChartPercentLegend: FC<BaseProps> = (props) => {
  const percentLabel = (label: string, value: number) => (
    <FormattedMessage
      id="legend/ChartLegend.tsx/2"
      values={{ label, formattedValue: numberWithSpaces(value) }}
    />
  );

  return <ChartLegend {...props} labelFormater={percentLabel} />;
};

type ChartLegendProps = BaseProps & {
  labelFormater: (label: string, value: number) => JSX.Element;
};

const ChartLegend: FC<ChartLegendProps> = ({
  data,
  labels,
  baseH,
  limit = 0,
  handleClick,
  labelFormater,
}) => {
  const { newData, newLabels } = mergeSlices({
    data,
    labels,
  });
  const colors = generateColorRange({
    baseH,
    minSL: 20,
    maxSL: 80,
    nb: newData.length,
  });
  const truncateIndex = limit || 10;
  return (
    <div className={styles.container}>
      <ChartLegendList
        data={newData.slice(0, truncateIndex)}
        renderItems={(items) =>
          items.map(({ clickable, value, i }) => (
            <ChartLegendItem
              key={i}
              clickable={clickable && !!handleClick}
              handleClick={(openInNewTab) =>
                handleClick && handleClick(openInNewTab, i)
              }
              label={labelFormater(newLabels[i], value)}
              color={colors[i]}
              hasBorder={i < items.length - 1}
            />
          ))
        }
      />
    </div>
  );
};
